import React from "react";
import "./SharedStyles.scss";
import { useSelector } from "react-redux";
import { State } from "../../store";
import useEmbedMode from "../../../features/EmbedNavigation/useEmbedMode";
import { useEmbedPageHeaderSlot } from "../../../features/EmbedNavigation/EmbedPageHeaderContext";
import EmbedToolbar from "../../../features/EmbedNavigation/EmbedToolbar";

interface IProps {
  title?: string;
  componentId?: string;
}

const EAPageHeader: React.FC<IProps> = ({ title = "", componentId = "" }) => {
  const saleConfiguration = useSelector((state: State) => state.config.configuration);
  const isEmbedMode = useEmbedMode();
  const showEmbedToolbar = useEmbedPageHeaderSlot(isEmbedMode);

  const getTitle = () => {
    if (title) {
      return title;
    } else if (saleConfiguration.componentList && componentId) {
      return saleConfiguration.componentList.find((item) => item.id === componentId)?.name;
    } else {
      return "";
    }
  };

  return (
    <div className={`page-header${isEmbedMode ? " page-header--embed" : ""}`}>
      <h1>{getTitle()}</h1>
      {showEmbedToolbar && <EmbedToolbar />}
    </div>
  );
};

export default EAPageHeader;
